<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-md-8">
                <CreateNewTeamForm
                    :rows="tbldata"
                    @updateGroupName="onUpdateGroupName"
                    @updateGroupDescription="onUpdateGroupDescription"
                    @error="onFormError"
                ></CreateNewTeamForm>

            </div>

            <div aria-live="polite" aria-atomic="true"
                 style="position: absolute;min-height: 200px;margin-top: -7%;margin-right: 20px;right: 0;">
                <div class="toast">
                    <div class="toast-header">
                        <strong class="mr-auto" style="color: red">Αποτυχία</strong>
                        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="toast-body">
                        Ο Έφεδρος που ζητήσατε, δεν μπόρεσε να βρεθεί. Παρακαλούμε ελέγξτε το ΑΣΜ του και δοκιμάστε εκ
                        νέου.
                    </div>
                </div>
            </div>
        </div>
        <div v-if="tbldata.length > 0" class="row justify-content-center">
            <div class="col-md-8">
                <TeamTable :rows.sync="tbldata"></TeamTable>
            </div>
        </div>
        <Message v-if="msgVisible" v-bind:msgClass="msgClass" v-bind:message="message"></Message>

        <div v-if="flag_special" class="alert alert-danger alert-dismissible fade show col-md-8" role="alert">

            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
import CreateNewTeamForm from './CreateNewTeamForm';
import TeamTable from './TeamTable';
import {HTTP} from "@/main.js";
import Message from '../Message.vue'

export default {
    name: "CreateTeam",
    components: {CreateNewTeamForm, TeamTable, Message},
    event: ['save:error', 'save:success'],
    data() {
        return {
            tbldata: [],
            flag_null: false,
            flag_ok: false,
            flag_prob: false,
            flag_special: false,
            namegroup: '',
            group_description: '',
            message: "",
            msgClass: "",
            msgVisible: ""
        }
    },
    created() {
    },
    mounted() {
        $('.toast').toast('dispose');
    },
    methods: {

        setMsg(status, msg) {
            this.message = msg;
            this.msgClass = status;
            this.msgVisible = true;
        },
        onFormError: function () {
            $('.toast').toast('show');
        },
        onUpdateGroupName: function (value) {
            this.namegroup = value
        },
        onUpdateGroupDescription: function (value) {
            this.group_description = value
        },
        createGroup: function () {
            let efedrosEfsa = [];

            if (this.$validator.isEmpty(this.namegroup) || this.$validator.isEmpty(this.group_description)) {
                this.setMsg('danger', 'Θα πρέπει να συμπληρώσετε το όνομα της ομάδας καθώς και την περιγραφή της προκειμένου να μπορέσει να δημιουργηθεί.');
                return;
            }
            if (this.$validator.containSpecialChars(this.namegroup) || this.$validator.containSpecialChars(this.group_description)) {
                this.setMsg('danger', 'Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου.');
                return;
            }

            let oTable = document.getElementById('fin_efedroi');
            if (oTable) {
                let rowLength = oTable.rows.length;
                for (let i = 1; i < rowLength; i++) {
                    let oCells = oTable.rows.item(i).cells;
                    efedrosEfsa.push(oCells.item(0).innerHTML);
                }
            }

            this.$store.dispatch('loading');

            var searchData = {
                "onoma": this.$validator.stripTags(this.namegroup),
                "perigrafh": this.$validator.stripTags(this.group_description),
                "moepKwd": this.$validator.stripTags(this.$store.getters.yphrKwd),
                "efedroi": efedrosEfsa
            };

            let ref = this;

            HTTP.post("/groups/", searchData)
                .then((response) => {
                    let resp = response.data;
                    this.setMsg('success', resp.message);
                    ref.$emit('save:success')
                })
                .catch((e) => {
                    console.error(e);
                    let resp = e.response;
                    this.setMsg('danger', (resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText);
                    ref.$emit('save:error', resp)
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        }
    }
}
</script>

<style scoped>

</style>